export const RCS_CONVERSATION_STATUS_PENDING = 0;
export const RCS_CONVERSATION_STATUS_ACTIVE = 1;
export const RCS_CONVERSATION_STATUS_ENDED = 2;
export const RCS_CONVERSATION_STATUS_TIMED_OUT = 3;
